<template>
  <svg
    class="filter-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="10.787"
    height="10.787"
    viewBox="0 0 10.787 10.787"
  >
    <g id="noun_filter_4174096" transform="translate(-2.5 -2.501)">
      <path
        id="Path_132"
        data-name="Path 132"
        d="M12.95,11.134H8.3a.337.337,0,1,0,0,.674H12.95a.337.337,0,1,0,0-.674Zm-10.112.674H6.548V12.95a.337.337,0,1,0,.674,0V9.992a.337.337,0,1,0-.674,0v1.142H2.837a.337.337,0,1,0,0,.674ZM12.95,3.98H10.18V2.838a.337.337,0,1,0-.674,0V5.8a.337.337,0,1,0,.674,0V4.654h2.77a.337.337,0,1,0,0-.674ZM2.5,4.317a.337.337,0,0,0,.337.337h5.59a.337.337,0,1,0,0-.674H2.837a.337.337,0,0,0-.337.337Zm10.45,3.24H6.708a.337.337,0,1,0,0,.674H12.95a.337.337,0,1,0,0-.674ZM2.5,7.894a.337.337,0,0,1,.337-.337H4.955V6.415a.337.337,0,1,1,.674,0V9.373a.337.337,0,1,1-.674,0V8.231H2.837A.337.337,0,0,1,2.5,7.894Z"
        fill="#707070"
        fill-rule="evenodd"
      />
    </g>
  </svg>
</template>
<script>
export default {
  name: 'FilterIcon'
};
</script>
